import Icon from '../components/Icon.vue'

Icon.register({
  'oil-can': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M629.8 160.3L416 224 365.5 198.8A64.1-64.1 0 0 1 336.9 192H280V144H336C344.8 144 352 136.8 352 128V112C352 103.2 344.8 96 336 96H176C167.2 96 160 103.2 160 112V128C160 136.8 167.2 144 176 144H232V192H176L37.7 166.9A31.9-31.9 0 0 1 31.9 166.3C14.7 166.3 0 180.4 0 198.3V293.3C0 308.8 11.1 322 26.3 324.8L96 337.5V384C96 401.7 110.3 416 128 416H402.6C411.2 416 419.4 412.6 425.4 406.5L637.6 191.7C639.1 190.2 640 188.2 640 186.1V168C640 162.7 634.9 158.9 629.8 160.3zM96 288.7L48 279.9V217.5L96 226.2V288.7zM549.3 373.3C549.3 396.9 568.4 416 592 416S634.7 396.9 634.7 373.3 592 288 592 288 549.3 349.8 549.3 373.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/oil-can.js
// module id = WjfE
// module chunks = 144